module.exports = __webpack_public_path__ + "img/eli-logo-white.255c9b2f.svg";